import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, formValueSelector, change } from 'redux-form';
import submit from './submit';
import validate from './validate';
import { connect } from 'react-redux';
import cx from 'classnames';
import { Button, Row, FormGroup, Col, Panel, Tabs, Tab } from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './CancellationPolicySharedForm.css';
import cs from '../../../components/commonStyle.css';
import { FormattedMessage, injectIntl } from 'react-intl';
import messages from '../../../locale/messages';
import MultiLanguageInput from '../MultiLanguageInput';

class CancellationPolicySharedForm extends Component {

    static propTypes = {
        initialValues: PropTypes.object,
        title: PropTypes.string,
        showTabs: PropTypes.bool,
        policyType: PropTypes.string,
        onPolicyChange: PropTypes.func,
    };

    handleFieldChange = (fieldName, value) => {
        const { dispatch } = this.props;
        dispatch(change('CancellationPolicySharedForm', fieldName, value));
    };

    render() {
        const { error, handleSubmit, submitting, initialValues, formValues, intl: { formatMessage }, showTabs, policyType, onPolicyChange } = this.props;

        return (
            <div className={cx(s.pagecontentWrapper, 'pagecontentAR')}>
                <div className={s.sectionCenter}>
                    <div className={s.formBackground}>
                        <div className={s.formInner}>
                            <div className={s.sectionTitle}>
                                <h2><FormattedMessage {...messages.cancellationPolicies} />{!showTabs && <> - <FormattedMessage {...messages.sharedContent} /></>}</h2>
                            </div>
                            
                            {/* Show tabs if integrated into main page */}
                            {showTabs && (
                                <Tabs
                                    activeKey={policyType}
                                    onSelect={(key) => onPolicyChange(key)}
                                    id="cancellation-policy-tabs-shared"
                                    className={cx(s.policyTabs, 'cancellationPolicyTabs')}
                                >
                                    <Tab eventKey="Flexible" title={formatMessage(messages.flexible)} />
                                    <Tab eventKey="Moderate" title={formatMessage(messages.moderate)} />
                                    <Tab eventKey="Strict" title={formatMessage(messages.strict)} />
                                    <Tab eventKey="Shared" title="Shared" />
                                </Tabs>
                            )}
                            
                            <form onSubmit={handleSubmit(submit)}>
                                {error && <span className={s.errorMessage}>{error}</span>}

                                {/* Subtítulo Principal */}
                                <Panel className={s.panelSection}>
                                    <Panel.Heading>
                                        <Panel.Title><FormattedMessage {...messages.mainSubtitle} /></Panel.Title>
                                    </Panel.Heading>
                                    <Panel.Body>
                                        <FormGroup className={s.formGroup}>
                                            <label className={cs.labelTextNew}>allowOwner</label>
                                            <MultiLanguageInput
                                                baseField="allowOwner"
                                                values={formValues}
                                                onChange={this.handleFieldChange}
                                                inputType="textarea"
                                                placeholder={formatMessage(messages.enterContent)}
                                            />
                                        </FormGroup>
                                    </Panel.Body>
                                </Panel>

                                {/* Títulos de Secciones */}
                                <Panel className={s.panelSection}>
                                    <Panel.Heading>
                                        <Panel.Title><FormattedMessage {...messages.sectionTitles} /></Panel.Title>
                                    </Panel.Heading>
                                    <Panel.Body>
                                        <Row>
                                            <Col md={4}>
                                                <FormGroup className={s.formGroup}>
                                                    <label className={cs.labelTextNew}>cancellationCheckIn</label>
                                                    <MultiLanguageInput
                                                        baseField="cancellationCheckIn"
                                                        values={formValues}
                                                        onChange={this.handleFieldChange}
                                                        inputType="text"
                                                        placeholder={formatMessage(messages.enterContent)}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md={4}>
                                                <FormGroup className={s.formGroup}>
                                                    <label className={cs.labelTextNew}>cancellationCheckOut</label>
                                                    <MultiLanguageInput
                                                        baseField="cancellationCheckOut"
                                                        values={formValues}
                                                        onChange={this.handleFieldChange}
                                                        inputType="text"
                                                        placeholder={formatMessage(messages.enterContent)}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md={4}>
                                                <FormGroup className={s.formGroup}>
                                                    <label className={cs.labelTextNew}>cancellationDescription</label>
                                                    <MultiLanguageInput
                                                        baseField="cancellationDescription"
                                                        values={formValues}
                                                        onChange={this.handleFieldChange}
                                                        inputType="text"
                                                        placeholder={formatMessage(messages.enterContent)}
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </Panel.Body>
                                </Panel>

                                {/* Descripción Punto 1 */}
                                <Panel className={s.panelSection}>
                                    <Panel.Heading>
                                        <Panel.Title><FormattedMessage {...messages.descriptionPoint} /> 1</Panel.Title>
                                    </Panel.Heading>
                                    <Panel.Body>
                                        <FormGroup className={s.formGroup}>
                                            <label className={cs.labelTextNew}>cancellationDesc1</label>
                                            <MultiLanguageInput
                                                baseField="cancellationDesc1"
                                                values={formValues}
                                                onChange={this.handleFieldChange}
                                                inputType="textarea"
                                                placeholder={formatMessage(messages.enterContent)}
                                            />
                                        </FormGroup>
                                    </Panel.Body>
                                </Panel>

                                {/* Descripción Punto 2 */}
                                <Panel className={s.panelSection}>
                                    <Panel.Heading>
                                        <Panel.Title><FormattedMessage {...messages.descriptionPoint} /> 2</Panel.Title>
                                    </Panel.Heading>
                                    <Panel.Body>
                                        <FormGroup className={s.formGroup}>
                                            <label className={cs.labelTextNew}>cancellationDesc2</label>
                                            <MultiLanguageInput
                                                baseField="cancellationDesc2"
                                                values={formValues}
                                                onChange={this.handleFieldChange}
                                                inputType="textarea"
                                                placeholder={formatMessage(messages.enterContent)}
                                            />
                                        </FormGroup>
                                    </Panel.Body>
                                </Panel>

                                {/* Descripción Punto 3 + Trip Start */}
                                <Panel className={s.panelSection}>
                                    <Panel.Heading>
                                        <Panel.Title><FormattedMessage {...messages.descriptionPoint} /> 3</Panel.Title>
                                    </Panel.Heading>
                                    <Panel.Body>
                                        <Row>
                                            <Col md={8}>
                                                <FormGroup className={s.formGroup}>
                                                    <label className={cs.labelTextNew}>cancellationDesc3</label>
                                                    <MultiLanguageInput
                                                        baseField="cancellationDesc3"
                                                        values={formValues}
                                                        onChange={this.handleFieldChange}
                                                        inputType="textarea"
                                                        placeholder={formatMessage(messages.enterContent)}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md={4}>
                                                <FormGroup className={s.formGroup}>
                                                    <label className={cs.labelTextNew}>cancellationTripStart</label>
                                                    <MultiLanguageInput
                                                        baseField="cancellationTripStart"
                                                        values={formValues}
                                                        onChange={this.handleFieldChange}
                                                        inputType="textarea"
                                                        placeholder={formatMessage(messages.enterContent)}
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </Panel.Body>
                                </Panel>

                                {/* Descripción Punto 4 */}
                                <Panel className={s.panelSection}>
                                    <Panel.Heading>
                                        <Panel.Title><FormattedMessage {...messages.descriptionPoint} /> 4</Panel.Title>
                                    </Panel.Heading>
                                    <Panel.Body>
                                        <FormGroup className={s.formGroup}>
                                            <label className={cs.labelTextNew}>cancellationDesc4</label>
                                            <MultiLanguageInput
                                                baseField="cancellationDesc4"
                                                values={formValues}
                                                onChange={this.handleFieldChange}
                                                inputType="textarea"
                                                placeholder={formatMessage(messages.enterContent)}
                                            />
                                        </FormGroup>
                                    </Panel.Body>
                                </Panel>

                                {/* Descripción Punto 5 */}
                                <Panel className={s.panelSection}>
                                    <Panel.Heading>
                                        <Panel.Title><FormattedMessage {...messages.descriptionPoint} /> 5</Panel.Title>
                                    </Panel.Heading>
                                    <Panel.Body>
                                        <FormGroup className={s.formGroup}>
                                            <label className={cs.labelTextNew}>cancellationDesc5</label>
                                            <MultiLanguageInput
                                                baseField="cancellationDesc5"
                                                values={formValues}
                                                onChange={this.handleFieldChange}
                                                inputType="textarea"
                                                placeholder={formatMessage(messages.enterContent)}
                                            />
                                        </FormGroup>
                                    </Panel.Body>
                                </Panel>

                                {/* Descripción Punto 6 + Review */}
                                <Panel className={s.panelSection}>
                                    <Panel.Heading>
                                        <Panel.Title><FormattedMessage {...messages.descriptionPoint} /> 6</Panel.Title>
                                    </Panel.Heading>
                                    <Panel.Body>
                                        <Row>
                                            <Col md={8}>
                                                <FormGroup className={s.formGroup}>
                                                    <label className={cs.labelTextNew}>cancellationDesc6</label>
                                                    <MultiLanguageInput
                                                        baseField="cancellationDesc6"
                                                        values={formValues}
                                                        onChange={this.handleFieldChange}
                                                        inputType="textarea"
                                                        placeholder={formatMessage(messages.enterContent)}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md={4}>
                                                <FormGroup className={s.formGroup}>
                                                    <label className={cs.labelTextNew}>cancellationReview</label>
                                                    <MultiLanguageInput
                                                        baseField="cancellationReview"
                                                        values={formValues}
                                                        onChange={this.handleFieldChange}
                                                        inputType="textarea"
                                                        placeholder={formatMessage(messages.enterContent)}
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </Panel.Body>
                                </Panel>

                                {/* Descripción Punto 7 */}
                                <Panel className={s.panelSection}>
                                    <Panel.Heading>
                                        <Panel.Title><FormattedMessage {...messages.descriptionPoint} /> 7</Panel.Title>
                                    </Panel.Heading>
                                    <Panel.Body>
                                        <FormGroup className={s.formGroup}>
                                            <label className={cs.labelTextNew}>cancellationDesc7</label>
                                            <MultiLanguageInput
                                                baseField="cancellationDesc7"
                                                values={formValues}
                                                onChange={this.handleFieldChange}
                                                inputType="textarea"
                                                placeholder={formatMessage(messages.enterContent)}
                                            />
                                        </FormGroup>
                                    </Panel.Body>
                                </Panel>

                                <FormGroup className={s.formGroup}>
                                    <Button
                                        bsSize="large"
                                        className={cx(cs.btnPrimary, cs.btnlarge)}
                                        type="submit"
                                        disabled={submitting}
                                    >
                                        <FormattedMessage {...messages.save} />
                                    </Button>
                                </FormGroup>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

CancellationPolicySharedForm = reduxForm({
    form: 'CancellationPolicySharedForm',
    validate,
    enableReinitialize: true,
    keepDirtyOnReinitialize: false
})(CancellationPolicySharedForm);

const selector = formValueSelector('CancellationPolicySharedForm');

const getMultiLangFields = (state, baseFields) => {
    const result = {};
    const langs = ['', '_en', '_fr', '_it', '_pt'];
    baseFields.forEach(field => {
        langs.forEach(lang => {
            const fieldName = `${field}${lang}`;
            result[fieldName] = selector(state, fieldName);
        });
    });
    return result;
};

const baseFields = [
    'allowOwner',
    'cancellationCheckIn',
    'cancellationCheckOut',
    'cancellationDescription',
    'cancellationDesc1',
    'cancellationDesc2',
    'cancellationDesc3',
    'cancellationTripStart',
    'cancellationDesc4',
    'cancellationDesc5',
    'cancellationDesc6',
    'cancellationReview',
    'cancellationDesc7'
];

const mapState = (state) => ({
    formValues: getMultiLangFields(state, baseFields)
});

const mapDispatch = { change };

export default injectIntl(withStyles(s, cs)(connect(mapState, mapDispatch)(CancellationPolicySharedForm)));
